export var SET_ORGANIZATION_DATA = '[ORGANZATION] SET DATA';
export var ADD_ORG_CLASSIFICATION = '[ORGANZATION] ADD CLASSIFICATION';
export var REMOVE_ORG_CLASSIFICATION = '[ORGANZATION] REMOVE CLASSIFICATION';
export var ADD_TAG_TO_PAGE = '[ORGANZATION] ADD TAG TO PAGE';
export var REMOVE_TAG_TO_PAGE = '[ORGANZATION] REMOVE TAG TO PAGE';
export var UPDATE_ORG_FEATURE = '[ORGANZATION] UPDATE FEATURE';
export var UPDATE_ORGANIZATION_LANGUAGES = '[ORGANZATION] UPDATE ORGANIZATION_LANGUAGES';
export var DEFINE_WHITELISTED_DOMAINS = '[ORGANZATION] DEFINE WHITELISTED DOMAINS';
export function setOrganizationData(organization) {
    return function (dispatch) {
        dispatch({
            type: SET_ORGANIZATION_DATA,
            payload: organization,
        });
    };
}
export function addOrgClassification(classification) {
    return function (dispatch) {
        dispatch({
            type: ADD_ORG_CLASSIFICATION,
            payload: classification,
        });
    };
}
export function updateOrgFeature(feature) {
    return function (dispatch) {
        dispatch({
            type: UPDATE_ORG_FEATURE,
            payload: feature,
        });
    };
}
export function updateOrgLanguages(organizationLanguages) {
    return function (dispatch) {
        dispatch({
            type: UPDATE_ORGANIZATION_LANGUAGES,
            payload: { organizationLanguages: organizationLanguages },
        });
    };
}
export function removeOrgClassification(classificationName) {
    return function (dispatch) {
        dispatch({
            type: REMOVE_ORG_CLASSIFICATION,
            payload: classificationName,
        });
    };
}
export function addPageTag(page, tag) {
    return function (dispatch) {
        dispatch({
            type: ADD_TAG_TO_PAGE,
            payload: { tag: tag, page: page },
        });
    };
}
export function removePageTag(page, tag) {
    return function (dispatch) {
        dispatch({
            type: REMOVE_TAG_TO_PAGE,
            payload: { tag: tag, page: page },
        });
    };
}
export function defineWhitelistedDomains(domains) {
    return function (dispatch) {
        dispatch({
            type: DEFINE_WHITELISTED_DOMAINS,
            payload: { domains: domains },
        });
    };
}



//////////////////
// WEBPACK FOOTER
// ./src/auth/store/actions/organization.actions.ts
// module id = 275
// module chunks = 81